import { render, staticRenderFns } from "./SmartSelect.vue?vue&type=template&id=c4522116"
import script from "./SmartSelect.vue?vue&type=script&lang=js"
export * from "./SmartSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports